// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__10AEM","delete":"styles_delete__O06BO","update":"styles_update__146MO","add":"styles_add__2D5U2"};